export default __webpack_public_path__ + "static/media/logo.c35c8fec.svg";